import HC from "../common/HighchartsBase"
const url = "https://app.vantetider.se/spa/1.1/rest/regionQueries/over90OperationRegionTrends";
import "../css/trend.css"
import styles from "styles-to-js-loader/styles"
var defaultChartOptions = {
    chart: {
        type: "spline",
        height: (9 / 16 * 100) + '%'
    },
    title: {
        text: "Totalt antal över 90 dagar"
    },
    xAxis: {
        categories: [],
        labels: {
            rotation: -45
        },
        tickWidth: 2,
    },
    yAxis: {
        title: {
            text: ""
        },
        min: 0,
        gridLineWidth: 0
    },
    legend: {
        align: 'center',
        verticalAlign: 'bottom',
        flaoting: true,
        enabled: true
    },
    credits: {
        enabled: false
    },
    tooltip: {
        useHTML: false,
        shared: false,
        formatter: function () {
            return '<b>' + this.series.name + ':</b> ' + this.y
        }
    },
    lang: {
        loading: "",
        noData: "Ingen data för valt urval",
        accessibility: {
            chartTypes: {
                splineSingle: "Linjediagram med {numPoints} antal datapunkter {#plural(numPoints, points, point)}."
            },
            axis: {
                xAxisDescriptionSingular: "Diagrammet har 1 X-axel som visar tid i månader",
                yAxisDescriptionSingular: "Diagrammet har 1 Y-axel som visar indikatorvärde."
            },
            screenReaderSection: {
                beforeRegionLabel: "Början av diagrammet",
                afterRegionLabel: "Slutet av diagrammet"
            }

        }
    },
    accessibility: {
        description: "Linjediagram som visar utvecklingen av väntande över 90 dagar för valda regioner"
    },
}
class over90Trend extends HC {
    constructor() {
        const temp = document.createElement("form");
        super(temp);
        this.template = temp;
        this.getShadow().appendChild(styles.get())
        this.showEmptyChart(this.template, defaultChartOptions);
        document.addEventListener("over90FilterSubmit", e => {
            if (this.chart)
                this.chart.showLoading();
            var params = e.detail;
            for (var property in params.values) {
                if (params.values.hasOwnProperty(property)) {
                    if (params.values[property] === "-1") {
                        delete params.values[property];
                    }
                }
            }
            this.getData(params, url, "series")
                .then(() => {
                    this.chartOptions = defaultChartOptions;
                    this.chartOptions.series = this.series;
                    defaultChartOptions.title.text = "Totalt antal över 90 dagar";
                    this.render(this.template);
                    this.setSubtitle(this.createSubtitleString(
                        (({ month, year, ...rest }) => rest)(params.text),
                        {monthAndYearAsTime: false, placeText: "Region"}));
                    if (this.chart)
                        this.chart.hideLoading();
                })
        }, { capture: true })
    }
}
if (!customElements.get("over90-trend-region")) {
    HC.define("over90-trend-region", over90Trend)
}
